import 'password-strength-meter/dist/password.min';
import 'password-strength-meter/dist/password.min.css';

import $ from 'jquery';

export function Profile() {
    if (!$('.u-profile-page').length) {
        return;
    }

    $(function() {
        var password_complexity = null;

        $(':password').password({
            shortPass: 'Пароль слишком короткий',
            containsUsername: 'Пароль не может содержать Ваше имя пользователя',
            strongPass: 'Сильный пароль',
            badPass: 'Слабый пароль, используйте буквы и цифры',
            goodPass: 'Средний пароль, используйте специальные символы',
            enterPass: null,
            username: $('#id_email'),
            minimumLength: 6,
        });

        $(':password').on('password.score', (e, score) => {
            password_complexity = score;
        });

        $('#signup_form').submit(function() {
            if ($('#id_password1').val() && $('#id_password2').val() && password_complexity < 20) {
                alert('Вы ввели слишком простой пароль');
                return false;
            }
        });
    });
}
